module.exports = __webpack_public_path__ + "media/images/member_fb-217b5510525ce2f0eb83ce01c1f2e0b6.svg";